import { IActionData } from '../types'
import TextWithIconTooltip from 'common-components/TextWithIconTooltip'
import * as Styled from './styled'

export const PrimaryActions = ({
  actionsData
}: {
  actionsData?: IActionData[]
}) => {
  if (!actionsData?.length) return null
  return (
    <Styled.PrimaryActionsWrapper>
      {actionsData.map(action => (
        <TextWithIconTooltip
          key={action.key}
          className={`iconWrapper ${action.key}`}
          tooltipText={action.title}
          iconProps={{
            icon: action.icon,
            size: 'small',
            color: 'secondarySemiDark'
          }}
          onClick={action.onClick}
        />
      ))}
    </Styled.PrimaryActionsWrapper>
  )
}
